import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type NotificationTestSlackCommand = {
    readonly _id: string;
    readonly _type: "NOTIFICATION_TEST_SLACK_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
};

type FactoryParams = Except<
    NotificationTestSlackCommand,
    "_id" | "_type" | "_createdAt"
>;
const notificationTestSlackCommandFactory = (params: FactoryParams) => {
    const notificationTestSlackCommand: NotificationTestSlackCommand = {
        ...params,
        _id: generateId({ prefix: "notification_test_slack_command__" }),
        _type: "NOTIFICATION_TEST_SLACK_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return notificationTestSlackCommand;
};

const notificationTestSlackCommandZodSchema: z.ZodSchema<NotificationTestSlackCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("NOTIFICATION_TEST_SLACK_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
    });

export {
    notificationTestSlackCommandFactory,
    notificationTestSlackCommandZodSchema,
};
export type {
    FactoryParams as CreateNotificationTestSlackCommandParams,
    NotificationTestSlackCommand,
};
